export default {
  priv: 'pr_manage',
  overviewTitle: 'Logging',
  url: '/manage/logging',
  apiUrl: '/logmessages/',
  sortBy: ['timestamp'],
  sortDesc: [true],
  deletable: false,
  editable: false,
  filterName: 'logmessages',
  quickFilter: {
    text: 'Zoek tekst',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {
      text: 'Zoek tekst',
      value: 'misc_search',
      type: 'text'
    },
    {
      text: 'Type',
      value: 'type_id',
      type: 'optionList',
      optionListName: 'logtypes'
    },
    {
      text: 'Gebruiker',
      value: 'user_id',
      type: 'optionList',
      optionListName: 'users'
    },
    {
      text: 'Periode van',
      value: 'date_start',
      type: 'date'
    },
    {
      text: 'Periode tot',
      value: 'date_end',
      type: 'date'
    }
  ],
  tableFields: [
    {
      text: 'Timestamp',
      value: 'timestamp',
      width: '15%',
      filter: 'timestamp'
    },
    {
      text: 'Type',
      value: 'type',
      width: '10%'
    },
    {
      text: 'Gebruiker',
      value: 'user',
      width: '10%'
    },
    {
      text: 'Categorie',
      value: 'category',
      width: '10%'
    },
    {
      text: 'ObjID',
      value: 'obj_id',
      width: '5%'
    },
    {
      text: 'Object',
      value: 'obj_name',
      width: '10%'
    },
    {
      text: 'Boodschap',
      value: 'message',
      width: '20%'
    },
    {
      text: 'Details',
      value: 'details',
      width: '10%'
    }
  ]
};
